import React from 'react'
import PropTypes from 'prop-types'
import StatusBadge from 'components/atoms/status-badge'
import { CONDITION } from 'domains/fast-sell-product/constants'

const propTypes = {
  condition: PropTypes.string
}

/**
 * @param {string} condition
 */
const FastSellProductConditionBadge = ({ condition }) => {

  const colorMap = {
    [CONDITION.BRAND_NEW] : 'success',
    [CONDITION.UNUSED]    : 'primary',
    [CONDITION.PERFECT]   : 'primary',
    [CONDITION.EXCELLENT] : 'info',
    [CONDITION.USED]      : 'warning',
    [CONDITION.VINTAGE]   : 'secondary'
  }

  const colorCondition = colorMap[condition] || 'default'

  return (
    <StatusBadge color={ colorCondition } label={ condition }/>
  )
}

FastSellProductConditionBadge.propTypes = propTypes

export default FastSellProductConditionBadge
